import { Button } from '@components/button';
import { Text } from '@components/text';
import { useToaster } from '@components/toaster';

import { useArchiveAll } from 'api/notifications/hooks';
import { Modal, ModalProps } from 'features/modals';
import { useStore } from 'models/Provider';

type Props = ModalProps<{
  latestId: number;
}>;

export const ArchiveAllModal = (props: Props) => {
  const { t } = useStore();
  const { showError, showSuccess } = useToaster();
  const archiveAll = useArchiveAll(props.latestId, {
    onSuccess: () => {
      props.closeModal();
      showSuccess(t('notifications.modals.archiveall.success'));
    },
    onError: () => {
      showError(t('notifications.modals.archiveall.error'));
    },
  });
  const submit = () => {
    archiveAll.mutate();
  };

  return (
    <Modal>
      <Modal.Header text={t('notifications.modals.archiveall.header')} />
      <Text text={t('notifications.modals.archiveall.text')} />
      <Modal.Actions>
        <Button
          variant="secondary"
          onClick={props.closeModal}
          isDisabled={archiveAll.isLoading}
          text={t('common.forms.button.cancel')}
        />
        <Button
          variant="primary"
          onClick={submit}
          isDisabled={archiveAll.isLoading}
          text={t('common.forms.button.submit')}
        />
      </Modal.Actions>
    </Modal>
  );
};
